module.exports = __webpack_public_path__ + "static/images/containers/ChallengeView/images/background-shooting-cn.a9f99b16.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ChallengeView/images/background-shooting-cn.jpg
// module id = 2819
// module chunks = 11